import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { Phone, MessageCircle, Instagram } from 'lucide-react';
import { useLanguage } from './LanguageContext';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/dmEeVyCNLLsP1vKt5zN2GP/logo_de_la_ruta.jpg';
export function CTASection() {
  const {
    t
  } = useLanguage();
  return <AnimatedSection id="contacto" className="bg-barber-gold text-barber-black" data-id="element-49">
      <div className="max-w-4xl mx-auto text-center" data-id="element-50">
        <img src={LOGO_URL} alt="JP Barber Mobile Supply" className="w-28 h-28 object-contain mx-auto rounded-xl mb-8" data-id="element-51" />
        <h2 className="text-4xl md:text-6xl font-oswald font-bold mb-6" data-id="element-52">
          {t.ctaSection.title}
        </h2>
        <p className="text-xl font-medium mb-12 opacity-90" data-id="element-53">
          {t.ctaSection.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12" data-id="element-54">
          <a href="https://wa.me/17185824903" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 bg-barber-black text-white px-8 py-4 rounded font-oswald text-xl font-bold hover:bg-gray-900 transition-colors" data-id="element-55">
            <MessageCircle size={24} className="text-green-500" data-id="element-56" />
            {t.ctaSection.btn1}
          </a>
          <a href="tel:+17185824903" className="flex items-center justify-center gap-3 bg-barber-black text-white px-8 py-4 rounded font-oswald text-xl font-bold hover:bg-gray-900 transition-colors" data-id="element-57">
            <Phone size={24} data-id="element-58" />
            {t.ctaSection.btn2}
          </a>
        </div>

        <div className="flex items-center justify-center gap-2 text-lg font-bold mb-8" data-id="element-59">
          <Instagram size={24} data-id="element-60" />
          <span data-id="element-61">@JPBarberSupply</span>
        </div>

        <div className="text-2xl font-oswald font-bold uppercase tracking-widest opacity-80" data-id="element-62">
          {t.ctaSection.footer}
        </div>
      </div>
    </AnimatedSection>;
}